const Onboarding = () => import(/* webpackChunkName: 'Onboarding' */ '@/Onboarding/Index');

export default [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: Onboarding,
    meta: { auth: true },
  },
];
